"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChildType = /** @class */ (function () {
    function ChildType() {
    }
    return ChildType;
}());
exports.ChildType = ChildType;
exports.CHILD_CREATION_BASIC = "BASIC";
exports.CHILD_CREATION_CHOICE = "CHOICE";
//# sourceMappingURL=ChildType.js.map